import React, { useState, useEffect } from "react";

import Image from "../Image";

import "./Timer.css";

export default function Timer({ imgTxt, txtColor }) {
  const imglink = `https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/${imgTxt}-stopwatch.svg`;
  const [seconds, setSeconds] = useState(600);
  const [isTimerRunning, setIsTimerRunning] = useState(true);

  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setIsTimerRunning(false);
    }
  }, [seconds]);

  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };
  return (
    <>
      {isTimerRunning && (
        <div className="mr_op">
          <div className="div_block_181447s502">
            <Image height={"20"} width={"20"} alt="timer" className="timer_logo" src={imglink} />
            <div className="text_block_9s8" style={{ color: txtColor }}>
              Free Slot Ends in {formatTime(seconds)}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
